import React, { useCallback, useContext } from "react";
import * as Sentry from "@sentry/react";
import { UI } from "@wwimmo/ui";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { GENDER } from "src/stores/OrderStore";

const ContactFormBase = () => {
    const { t } = useTranslation();
    const { orderStore } = useContext(RootStoreContext);

    // Translation values for salutations
    const salutationMale = t("screens.tickets.form.person.gender_1");
    const salutationFemale = t("screens.tickets.form.person.gender_2");
    const salutationDivers = t("screens.tickets.form.person.gender_3");
    const salutationCompany = t("screens.tickets.form.person.gender_0");

    const handleInputChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
            const { name, value } = e.target;
            orderStore.setOrderContactPerson(name as keyof typeof orderStore.orderContactPerson, value);
        },
        [orderStore]
    );

    return (
        <UI.Container className="pt-4 pl-0">
            <UI.Row className="d-flex flex-wrap">
                {/* First Column: Anrede, Vorname, Nachname */}
                <UI.Col md={7} xs={12}>
                    {/* Anrede (Salutation) */}
                    <UI.Row>
                        <UI.Col md={5} xs={12}>
                            <UI.Input
                                label={t("screens.tickets.form.person.salutation")}
                                name="salutation"
                                as="select"
                                onChange={handleInputChange}
                                value={orderStore.orderContactPerson.salutation || ""}
                            >
                                <option value="" disabled hidden></option>
                                <option value={`${salutationMale};${GENDER.MALE}`}>{salutationMale}</option>
                                <option value={`${salutationFemale};${GENDER.FEMALE}`}>{salutationFemale}</option>
                                <option value={`${salutationDivers};${GENDER.NEUTRAL}`}>{salutationDivers}</option>
                                <option value={`${salutationCompany};${GENDER.LEGAL_PERSON}`}>
                                    {salutationCompany}
                                </option>
                            </UI.Input>
                        </UI.Col>
                    </UI.Row>
                    {/*(Firstname and Lastname) */}
                    <UI.Row>
                        <UI.Col md={5} xs={12}>
                            <UI.Input
                                name="name1"
                                label={
                                    orderStore.orderContactPerson.salutation?.split(";")[1] === "0"
                                        ? t("screens.tickets.form.person.firstname_company")
                                        : t("screens.tickets.form.person.firstname")
                                }
                                type="text"
                                value={orderStore.orderContactPerson.name1}
                                onChange={handleInputChange}
                            />
                        </UI.Col>
                        <UI.Col md={7} xs={12}>
                            <UI.Input
                                name="name2"
                                label={
                                    orderStore.orderContactPerson.salutation?.split(";")[1] === "0"
                                        ? t("screens.tickets.form.person.lastname_company")
                                        : t("screens.tickets.form.person.lastname")
                                }
                                type="text"
                                value={orderStore.orderContactPerson.name2}
                                onChange={handleInputChange}
                            />
                        </UI.Col>
                    </UI.Row>
                </UI.Col>
                {/* Second Column: E-Mail, Mobile, Telefon Privat */}
                <UI.Col md={5} xs={12}>
                    <UI.Row>
                        <UI.Col xs={12}>
                            <UI.Input
                                name="email"
                                label={t("screens.tickets.form.person.email")}
                                value={orderStore.orderContactPerson.email}
                                onChange={handleInputChange}
                                type="email"
                                iconRight={<UI.Icon icon={UI.SVGIcon.Mail} color="grey" size={"medium"} />}
                            />
                        </UI.Col>
                        <UI.Col xs={12}>
                            <UI.Input
                                name="mobile"
                                label={t("screens.tickets.form.person.mobile")}
                                value={orderStore.orderContactPerson.mobile}
                                onChange={handleInputChange}
                                type="tel"
                                iconRight={<UI.Icon icon={UI.SVGIcon.Device} color="grey" size={"medium"} />}
                            />
                        </UI.Col>
                        <UI.Col xs={12}>
                            <UI.Input
                                name="phone"
                                label={t("screens.tickets.form.person.phone_private")}
                                value={orderStore.orderContactPerson.phone}
                                onChange={handleInputChange}
                                type="tel"
                                iconRight={<UI.Icon icon={UI.SVGIcon.Device} color="grey" size={"medium"} />}
                            />
                        </UI.Col>
                    </UI.Row>
                </UI.Col>
            </UI.Row>
        </UI.Container>
    );
};

export const ContactForm = Sentry.withProfiler(observer(ContactFormBase));
